import { render, staticRenderFns } from "./cover4.vue?vue&type=template&id=91b9d7fe&scoped=true&"
import script from "./cover4.vue?vue&type=script&lang=js&"
export * from "./cover4.vue?vue&type=script&lang=js&"
import style0 from "./cover4.vue?vue&type=style&index=0&id=91b9d7fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b9d7fe",
  null
  
)

export default component.exports